import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ErrorScreen from '../ErrorScreen';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const { onCatch } = this.props;

    if (onCatch) {
      onCatch(error, errorInfo);
    }
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <>
          <ErrorScreen />
        </>
      );

      // Display individual message.
      // if (error && error.message) {
      //   return <small>{error.message}</small>;
      // }

      // Or you can render any custom fallback UI
      // return <small>Something went wrong</small>;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  onCatch: PropTypes.func
};

export default ErrorBoundary;
